export default __webpack_public_path__ + "298e12ced1a28879db9ccd740f349f54.svg";